// Rondia Room — Theme JS
// Mobile menu + product gallery thumbnails

document.addEventListener('DOMContentLoaded', function () {

  // ---- Mobile menu toggle ----
  var toggle = document.querySelector('.header__menu-toggle');
  var mobileNav = document.getElementById('mobile-nav');

  if (toggle && mobileNav) {
    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      mobileNav.setAttribute('aria-hidden', String(expanded));
      mobileNav.classList.toggle('is-open');
    });
  }

  // ---- Product gallery thumbnails ----
  var thumbBtns = document.querySelectorAll('.thumb-btn');
  var mainImage = document.getElementById('main-product-image');

  if (thumbBtns.length && mainImage) {
    thumbBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-src');
        if (src) { mainImage.src = src; }
        thumbBtns.forEach(function (b) { b.classList.remove('thumb-btn--active'); });
        btn.classList.add('thumb-btn--active');
      });
    });
  }

  // ---- Product Carousel ----
  (function () {
    var carousel = document.getElementById('product-carousel');
    var track    = document.getElementById('carousel-track');
    var prevBtn  = document.getElementById('carousel-prev');
    var nextBtn  = document.getElementById('carousel-next');

    if (!carousel || !track || !prevBtn || !nextBtn) return;

    var slides   = Array.prototype.slice.call(track.querySelectorAll('.carousel__slide'));
    var total    = slides.length;
    var current  = 0;
    var autoTimer = null;
    var DELAY    = 4000;
    var GAP      = 2; // matches CSS gap: 2px

    function getSlidesVisible() {
      if (window.innerWidth <= 540) return 1;
      if (window.innerWidth <= 900) return 2;
      return 4;
    }

    function setWidths() {
      var wrap    = track.parentElement;
      var visible = getSlidesVisible();
      var totalGap = GAP * (visible - 1);
      var w = Math.floor((wrap.offsetWidth - totalGap) / visible);
      slides.forEach(function (s) { s.style.width = w + 'px'; });
    }

    function goTo(index) {
      var visible = getSlidesVisible();
      var maxIdx  = Math.max(0, total - visible);
      if (index < 0)      index = maxIdx;
      if (index > maxIdx) index = 0;
      current = index;
      var w = slides[0] ? slides[0].offsetWidth : 0;
      track.style.transform = 'translateX(-' + (current * (w + GAP)) + 'px)';
    }

    function startAuto() {
      stopAuto();
      autoTimer = setInterval(function () { goTo(current + 1); }, DELAY);
    }

    function stopAuto() {
      clearInterval(autoTimer);
      autoTimer = null;
    }

    prevBtn.addEventListener('click', function () { goTo(current - 1); startAuto(); });
    nextBtn.addEventListener('click', function () { goTo(current + 1); startAuto(); });

    carousel.addEventListener('mouseenter', stopAuto);
    carousel.addEventListener('mouseleave', startAuto);

    window.addEventListener('resize', function () {
      setWidths();
      var visible = getSlidesVisible();
      var maxIdx  = Math.max(0, total - visible);
      if (current > maxIdx) current = maxIdx;
      goTo(current);
    });

    // Initialise
    setWidths();
    goTo(0);
    startAuto();
  })();

});
